<template>
  <saml
    :tier="tier"
    :is-editable="isEditable"
    :identity-provider="identity_provider"
    :uuid="customerGlobalOrganisationId || ''"
  ></saml>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { TIER } from "@/constants";
import Saml from "../../Common/Saml/index.vue";
import { useGlobalOrganisationID } from "@/composables/useGlobalOrganisationID";
import { useI18n } from "vue-i18n";
import { useSsoStore } from "@/modules/Settings/store/sso.store";
import { usePageMetaStore } from "@/store/pageMeta.store";

const { t } = useI18n();
const pageMetaStore = usePageMetaStore();
const ssoStore = useSsoStore();
const isEditable = ref({
  sso: false,
  configured: false,
});
const identity_provider = ref({
  login_url: "",
  logout_url: "",
  entity_id: "",
  certificate: "",
  attributes: {
    attr_claim: "",
    email: "",
  },
  default_login_enabled: false,
});
const setPageTitle = (title: string) => pageMetaStore.setPageTitle({ title });

const tier = computed(() => TIER.customer);
const { customerGlobalOrganisationId } = useGlobalOrganisationID();

onMounted(async () => {
  try {
    isEditable.value = await ssoStore.ssoConfiEnabled({
      uuid: customerGlobalOrganisationId.value,
    });

    if (isEditable.value.configured) {
      identity_provider.value = await ssoStore.showSSOconfig({
        uuid: customerGlobalOrganisationId.value,
      });
    }
  } finally {
    setPageTitle(t("saml-sso"));
  }
});
</script>
